import React from "react";
import { Link } from "react-router-dom";
import hero_logo from "../dist/img/hero_logo.png";
import bg_video from "../dist/img/output_movie.mov";

const StartPage = () => {
  return (
    <section className="p-hero">
      <video poster="" autoPlay loop playsInline muted>
        <source src={""} type="video/mp4"></source>
      </video>

      <section className="p-hero__content">
        <img className="p-hero__logo" src={hero_logo} alt="" />
        <section className="p-hero__box c-box c-box--white">
          <h1 className="p-hero__title">
            ONLINE <br className="u-sp" />
            COUNSELING
            <br />
            <span>オンラインカウンセリング</span>
          </h1>
          <p>
            お客様の髪質、ご希望のケア効果を
            <br className="u-sp" />
            お選びください。
            <br />
            最適なシステムトリートメントを
            <br className="u-sp" />
            ご提案いたします。
          </p>

          <Link to="/questions">START</Link>
        </section>
      </section>
    </section>
  );
};

export default StartPage;
